import { Stack, TextField } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { CrudPage } from '../../shared/components/CrudPage';
import { resources } from '../../core/services/resources';
import type { PromptFunnelStage } from '../../core/types/data-models';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 200 },
  { field: 'description', headerName: 'Description', flex: 2, minWidth: 280 },
];

export function PromptFunnelStagesPage() {
  return (
    <CrudPage<PromptFunnelStage>
      title="Prompt funnel stages"
      description="Stages of the funnel a prompt targets (e.g. AWARENESS, CONSIDERATION, PURCHASE)."
      cacheKey={['prompt-funnel-stages']}
      service={resources.promptFunnelStages}
      columns={columns}
      defaultValues={{ name: '', description: '' }}
      renderForm={({ values, setValues }) => (
        <Stack spacing={2}>
          <TextField label="Name" required value={values.name ?? ''} onChange={(e) => setValues({ ...values, name: e.target.value })} />
          <TextField label="Description" multiline minRows={3} value={values.description ?? ''} onChange={(e) => setValues({ ...values, description: e.target.value })} />
        </Stack>
      )}
    />
  );
}
